import Head from "next/head";
import { make as PbePage } from "../../src/info/PbePage.bs";

export default function Pbe({ data, updated }) {
  return (
    <>
      <Head>
        <title>Pbe Patch Notes - Tft Stats & Tools</title>
      </Head>
      <PbePage data={data} updated={updated} />
    </>
  );
}

export async function getStaticProps({ locale }) {
  const resp = await fetch(`https://ap.tft.tools/static/pbe/${locale}.json`);
  const json = await resp.json();

  return {
    props: {
      data: json.data,
      updated: json.updated,
    },
    revalidate: 3600,
  };
}
